<template>
  <div class="eBanking">
    <div class="info">
      <p class="title">{{pc_lang.Payment_steps}}</p>
      <div class="stepWrap">
        <el-steps :active="stepActive" align-center>
          <el-step :title="pc_lang.Complete_the_transfer" description=""></el-step>
          <el-step :title="pc_lang.submit_application" description=""></el-step>
          <el-step :title="pc_lang.Waiting_for_confirmation" description=""></el-step>
        </el-steps>
      </div>

      <!-- 第一步 -->
      <div class="step step_1" v-show="stepActive == 0">
        <div class="notice">
          ⓘ{{pc_lang.Perform_mutitop_up_at_one_time_avoid_transferring_integer_amounts_such_as_RM100_RM50_etc_Adding_a_decimal_point_such_as_RM10003_or_RM49_for_easy_verification}}
        </div>
        <!-- 账号持有者 -->
        <!-- <div class="belong">
          <h5><span>{{pc_lang.Account_holder}}：</span>Asia5B Sdn Bhd</h5>
        </div> -->
        <!-- 转账银行 -->
        <div class="bank">
          <table>
            <caption>{{pc_lang.Please_select_the_transfer_bank}}</caption>
            <tbody>
              <tr v-for="item in companyBank" :key="item.bank_account">
                <!-- 账号持有者 -->
                <td>{{ `${pc_lang.Account_holder}: ${item.account_name}` }}</td>
                <td v-text="item.bank_account"></td>
                <td>
                  <a :href="item.web_url" target="blank" v-text="`${item.bank_name} ` + pc_lang.Main_site"></a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="notice">
          ⓘ{{pc_lang.Transaction_notice}}
        </div>
        <div class="submit">
          <el-button type="primary" size="medium" class="nextStep" @click="stepActive = 1">{{pc_lang.Transfer_completed}}</el-button>
        </div>
      </div>

      <!-- 第二部 -->
      <div class="step step_2" v-show="stepActive == 1">
        <h4>{{pc_lang.Please_fill_in_the_transfer_information_for_the_financial_department_to_confirm_the_payment}}：</h4>
        <el-form :model="eBankingForm" :rules="rulesForm" ref="eBankingForm" label-width="0" class="eBankingForm">
          <el-form-item prop="amount">
            <p>{{pc_lang.Amount}} <font style="color:red">*</font></p>
            <el-input v-model="eBankingForm.amount" prefix-icon="el-icon-money" autocomplete="off" :placeholder="pc_lang.Please_enter_the_amount" size="medium"></el-input>
          </el-form-item>
          <el-form-item prop="tradeIds" class="tradeIds">
            <p>{{ pc_lang['After_successful_payment'] }}</p>
            <!-- <el-input v-model="eBankingForm.tradeIds" prefix-icon="el-icon-mobile-phone" autocomplete="off" :placeholder="pc_lang.Please_enter_the_Hp_No" size="medium"></el-input> -->
            <div class="checkWrap">
              <el-checkbox-group v-model="eBankingForm.tradeIds">
                <el-checkbox v-for="item in unpayList" :key="item.trade_id" :label="item.trade_id">
                  {{ item.trade_notes }} / {{ item.currency_short }} {{ item.amount }}
                </el-checkbox>
              </el-checkbox-group>
            </div>
          </el-form-item>
          <el-form-item prop="mobile" v-show="false">
            <p>{{pc_lang.Ho_No}}</p>
            <el-input v-model="eBankingForm.mobile" prefix-icon="el-icon-mobile-phone" autocomplete="off" :placeholder="pc_lang.Please_enter_the_Hp_No" size="medium"></el-input>
          </el-form-item>
          <el-form-item prop="inBankId">
            <p>{{pc_lang.Transfer_to_bank}} <font style="color:red">*</font></p>
            <el-select v-model="eBankingForm.inBankId" :placeholder="pc_lang.Please_choose_to_transfer_to_bank" size="medium" @change="changeInBankId">
              <el-option :label="item.bank_name" :value="item.bank_id" v-for="item in bankList.intoBank" :key="item.bank_id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="inBankAccount">
            <p>{{pc_lang.Transfer_to_bank_account}} <font style="color:red">*</font></p>
            <el-select v-model="eBankingForm.inBankAccount" :placeholder="pc_lang.Please_choose_to_transfer_to_bank_account" size="medium">
              <el-option v-for="item in bankAccountList" :label="item.account_name" :value="item.bank_account" :key="item.bank_account">
                <span style="float: left">{{ item.account_name }}</span>
                <span style="float: right; margin-right: 10px; color: #8492a6; font-size: 13px">{{ item.bank_account }}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="outBankId">
            <p>{{pc_lang.Transfer_from_bank}}</p>
            <el-select v-model="eBankingForm.outBankId" :placeholder="pc_lang.Please_select_a_transfer_from_bank" size="medium">
              <el-option :label="item.bank_name" :value="item.bank_id" v-for="item in bankList.outBank" :key="item.bank_id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="serialNumber">
            <p>{{pc_lang.reference_number}}</p>
            <el-input v-model="eBankingForm.serialNumber" prefix-icon="el-icon-notebook-1" autocomplete="off" :placeholder="pc_lang.Please_enter_the_reference_number" size="medium"></el-input>
          </el-form-item>
          <el-form-item prop="transferTime">
            <p>{{pc_lang.Transfer_time}}</p>
            <el-date-picker
              v-model="eBankingForm.transferTime"
              type="datetime"
              size="medium"
              value-format="timestamp"
              change="dateReg"
              :placeholder="pc_lang.Please_select_a_transfer_time">
            </el-date-picker>
          </el-form-item>
          <el-form-item prop="remark">
            <p>{{pc_lang.remark}}</p>
            <el-input v-model="eBankingForm.remark" prefix-icon="el-icon-s-order" autocomplete="off" :placeholder="pc_lang.Please_enter_remark" size="medium"></el-input>
          </el-form-item>
          <el-form-item prop="credentials" class="credentials">
            <p>{{pc_lang.Upload_receipt2}} <font style="color:red">*</font></p>
            <el-upload
              class="avatar-uploader"
              action=""
              :show-file-list="false"
              :before-upload="beforeAvatarUpload">
              <img v-if="imageUrl" :src="imageUrl" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>

            <el-input v-model="eBankingForm.credentials" autocomplete="off" size="medium" v-show="false"></el-input>
          </el-form-item>
        </el-form>
        <div class="submit">
          <el-button type="primary" size="medium" class="nextStep" @click="regForm('eBankingForm')">{{pc_lang.Submit_top_up}}</el-button>
        </div>
      </div>

      <!-- 第三步 -->
      <div class="step step_3" v-show="stepActive == 3">
        <Finish
        v-if="stepActive == 3"
        :mainTitle="pc_lang.top_up_successful"
        :descWord="pc_lang.Please_wait_patiently_for_the_verification_revert_back_a_message_once_completed_Refer_top_up_status_for_transaction_history"
        :routeA="'/riches'"
        :routeWordA="pc_lang.My_Credit"
        :routeB="'fresh'"
        :routeWordB="pc_lang.Next_top_up"
        :btnBool="true"
        :countBool="false"
        ></Finish>
      </div>

    </div>
  </div>
</template>

<script>
import * as RegExp from '@/utils/RegExp'
import Finish from '@/components/ui/Finish'
import both from '@/utils/storage'

import * as API_BANK from '@/api/bank'
import * as API_PAY from '@/api/pay'
import {bankAccountList} from "@/api/pay";

export default {
  name: 'EBanking',
  props: ['currencyShort'],
  components: {
    Finish
  },
  data(){
    return {
      // step
      stepActive: 0,
      // 表单
      eBankingForm: {
        type: 'ebanking',
        amount: '',
        mobile: '',
        inBankId: '',
        inBankAccount: '',
        outBankId: '',
        serialNumber: '',
        currencyShort: this.currencyShort,
        transferTime: '',
        credentials: '',
        img: '',
        tradeIds: [],
        remark: '',
      },
      // 凭证回显
      imageUrl: '',
      /* 银行列表 */
      bankList: {},
      /* 公司银行列表 */
      companyBank: [],
      /* 待付款订单 */
      unpayList: [],
      bankAccountList: []
    }
  },
  computed: {
      // 表单验证
    rulesForm() {
      // 信用卡号验证
      var validateCVV2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.pc_lang.Enter_CVV2));
        } else if (!/^[0-9]{3}$/.test(value)) {
          callback(new Error(this.pc_lang.Enter_the_correct_CVV2));
        } else {
          callback();
        }
      };
      // 金额验证
      var validateMoney = (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.pc_lang.Please_enter_the_amount));
        } else if (!RegExp.money.test(value)) {
          callback(new Error(this.pc_lang.Please_enter_the_correct_amount));
        } else {
          callback();
        }
      };
      // 到期时间
      var validateTime = (rule, value, callback) => {
        console.log(value)
        if (value > new Date().getTime()) {
          callback(new Error(this.pc_lang.Enter_the_correct_transfer_time));
        } else {
          callback();
        }
      };
      return {
        amount: [
          { validator: validateMoney, trigger: 'blur' }
        ],
        /*mobile: [
          { required: true, message: this.pc_lang.Please_enter_the_Hp_No, trigger: 'blur' }
        ],*/
        inBankId: [
          { required: true, message: this.pc_lang.Please_choose_to_transfer_to_bank, trigger: 'change' }
        ],
        inBankAccount: [
          { required: true, message: this.pc_lang.Please_choose_to_transfer_to_bank_account, trigger: 'change' }
        ],
        /*outBankId: [
          { required: true, message: this.pc_lang.Please_select_a_transfer_from_bank, trigger: 'change' }
        ],
        serialNumber: [
          { required: true, message: this.pc_lang.Please_enter_the_reference_number, trigger: 'blur' }
          // { validator: validateCardNo, trigger: 'blur' }
        ],*/
        transferTime: [
          { validator: validateTime, trigger: 'change' }
          // { required: true, message: '请选择信用卡到期时间', trigger: 'blur' }
        ],
        credentials: [
          { required: true, message: this.pc_lang.Upload_receipt, trigger: 'change' }
          // { validator: validateCVV2, trigger: 'blur' }
        ]
      }
    }
  },
  async mounted() {

  },
  created() {
    this.getBank()
    this.getCompanyBank()
    this.getUnpaidList()
  },
  methods: {
    /* 重置表单 */
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    /* 表单验证 */
    regForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          Promise.resolve(this.rechargeApply()).then((res)=>{
            this.stepActive = 3
            window.scrollTo(0, 282)
          },rej=> {
            this.$message_box.alert(rej.msg, this.pc_lang.Submission_Failed, {
              confirmButtonText: this.pc_lang.Confirm2
            });
          })
        }else{
          return false
        }
      })
    },
    zipImg(file) {
      return new Promise((resolve,reject)=> {
        let tempImg = new Image()
        tempImg.src = URL.createObjectURL(file)
        tempImg.onload = (()=>{
          both.imageCompress(file,{
            // size,
            width:tempImg.width < 800 ? tempImg.width : 800,
            // height,
            // fileType,
            qualityArgument:0.8
          }).then(blob=>{
            resolve(blob)
          })
        })

        tempImg.onerror = (()=>{
          reject(this.pc_lang.Fail_to_upload)
        })
      })
    },
    // 上传凭证
    async beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type == 'image/png';
      if (isJPG) {
        this.zipImg(file).then(res=> {
          this.imageUrl = URL.createObjectURL(res)
          this.eBankingForm.img = res
          this.eBankingForm.credentials = 123
          return false
        }).catch(err=>console.log(err))
      } else {
          this.imageUrl = `image/checked.png`
          this.eBankingForm.img = file
          this.eBankingForm.credentials = 123
          return false
      }
      return false
    },
    // 继续充值
    still() {
      this.resetForm('eBankingForm')
      this.stepActive = 0
    },
    /* 获取转入转出银行 */
    getBank() {
      let params = {
        currencyShort: this.currencyShort,
        bankType: 'ebanking'
      }
      API_BANK.getBankList(params).then(res=> {
        this.bankList = res.data
      },rej=>(console.log(rej)))
    },
    /* 获取公司银行 */
    getCompanyBank() {
      let params = {
        currencyShort: this.currencyShort,
        bankType: 'ebanking'
      }
      API_BANK.getCompanyBank(params).then(res=> {
        this.companyBank = res.data
      },rej=>(console.log(rej)))
    },
    /* 充值申请 */
    rechargeApply() {
      let formItem = { ...this.eBankingForm }
      formItem.tradeIds = formItem.tradeIds.join(',')
      let params = new FormData()
      for(let k in formItem) {
        params.append(k, formItem[k])
      }
      return new Promise((resolve, reject)=> {
        API_BANK.rechargeApply(params).then(res=> {
          resolve()
        },rej=>(reject(rej)))
      })
    },
    /* 获取未付款订单列表 */
    getUnpaidList() {
      API_PAY.unpaidList().then(res=> {
        this.unpayList = res.data
      })
    },
    changeInBankId() {
      var params = {
        bankType: 'ebanking',
        bankId: this.eBankingForm.inBankId
      }
      bankAccountList(params).then(res => {
        if(res.code === '200' || res.code === 200){
          this.eBankingForm.inBankAccount = ''
          this.bankAccountList = res.data
          if(this.bankAccountList.length === 1){
            this.eBankingForm.inBankAccount = this.bankAccountList[0].bank_account
          }
        }else{
          this.$message.error(res.msg)
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.eBanking{
  width: 800px;
  p.title{
    font-size: 20px;
  }
  .stepWrap{
    padding: 40px 0 0;
  }
  .notice{
    color: #666666;
    margin: 40px 0;
  }
  .belong{
    margin-bottom: 24px;
    span{
      font-weight: 500;
      font-size: 20px;
    }
    h5{
      font-size: 20px;
    }
  }
  .tradeIds{
    .checkWrap{
      // border-bottom: $border;
      // border-color: #f2f2f2;
      border-radius: 6px;
      // padding: 5px 10px;
    }
  }
  .bank{
    padding: 12px 20px 20px;
    @extend .border;
    caption{
      text-align: center;
      font-weight: 600;
      font-size: 18px;
      color: #333;
      padding: 10px;
    }
    tr{
      border-bottom: $border;
    }
    td{
      padding: 10px 5px;
      color: #555;
      &:first-child{
        text-align: left;
        width: 300px;
      }
      &:nth-child(2){
        width: 160px;
        text-align: center;
      }
      &:last-child{
        text-align: right;
      }
    }
    a{
      color: $blue;
      @extend .transition;
      &:hover{
        color: lighten($blue, 10%);
        cursor: pointer;
        @extend .transition;
      }
    }
  }
  .submit{
    p{
      padding: 10px 0;
      font-size: 12px;
      span{
        color: #007DD1;
        cursor: pointer;
      }
    }
  }
  .el-input,.el-select{
    width: 450px;
  }
  .el-form-item{
    margin-bottom: 14px;
  }

  .credentials{
    margin-bottom: 24px;
  }
  .finish{
    text-align: center;
    width: 436px;
    margin: 40px auto;
    i{
      font-size: 24px;
    }
    >div{
      font-size: 28px;
      margin-bottom: 10px;
      color: $blue;
    }
    p{
      margin: 20px;
      color: #555;
      span{
        color: $blue;
      }
    }
  }

}
</style>

<style>
  .credentials .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    &:hover{
      border-color: #409EFF;
    }
  }
  .credentials .avatar-uploader {
    height: 106px;
  }
  .credentials .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
  }
  .credentials .avatar {
    width: 100px;
    height: 100px;
    display: block;
    object-fit: cover;
  }
</style>
